import apiService from "./ApiService"
import { createQS } from "./Utils"

class UsuarioService {

  async get(termo, idPerfil, idEmpresa, pagina) {
    try {
      const qs = createQS({ termo, idPerfil, idEmpresa, pagina })
      return await apiService.get('usuario?' + qs)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async getById(id) {
    try {
      return await apiService.get('usuario/' + id)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async getEquipeAtualById(id) {
    try {
      return await apiService.get(`usuario/${id}/equipe_atual`)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async create(data) {
    try {
      return await apiService.post('usuario', data)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }
  
  async update(id, data) {
    try {
      return await apiService.put('usuario/' + id, data)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async delete(id) {
    try {
      return await apiService.delete('usuario/' + id)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }
}

const usuarioService = new UsuarioService()
export default usuarioService